import moment from "moment";

const datePattern = (
  value,
  dateFormat,
  sep,
  startYear,
  endYear,
  allowFuture,
  allowPast,
  maxDate,
  minDate
) => {
  const format = dateFormat.split(sep);
  const lastIndex = format.length - 1;
  let currVal = value.split(sep);

  const dayIndex =
    format.indexOf("DD") !== -1 ? format.indexOf("DD") : format.indexOf("D");
  const monthIndex =
    format.indexOf("MM") !== -1 ? format.indexOf("MM") : format.indexOf("M");
  const yearIndex =
    format.indexOf("YYYY") !== -1
      ? format.indexOf("YYYY")
      : format.indexOf("YY");
  let dayValue = currVal[dayIndex];
  let monthValue = currVal[monthIndex];
  let yearValue = currVal[yearIndex];

  let isFutureDate = false;
  let isPastDate = false;
  if (+dayValue > 31) {
    dayValue = 31;
    currVal[dayIndex] = 31;
  }
  if (+monthValue > 12) {
    monthValue = 12;
    currVal[monthIndex] = 12;
  }

  if (currVal.includes("00") || currVal.includes(" ")) {
    if (currVal[yearIndex]?.includes("00")) {
    } else {
      return;
    }
  }

  const validate = (inputValue, format) => {
    return moment(inputValue, format, true).isValid();
  };

  const checkSeperator = (inputValue, index, append = false) => {
    if (!(value.charAt(value.length - 1) === sep)) {
      inputValue = inputValue.slice(0, -1);
    }
    if (index === lastIndex) {
      if (inputValue.length === 1) {
        inputValue = (append ? "0" : "") + inputValue;
      } else if (inputValue.length === 2) {
      }
    } else if (inputValue.length === 2) {
      inputValue = inputValue + sep;
    } else if (inputValue >= 1 && inputValue <= 9) {
      inputValue = (append ? "0" : "") + inputValue + sep;
    }
    return inputValue;
  };

  const checkCorrectDate = (index, prevIndex) => {
    if (
      prevIndex !== -1 &&
      prevIndex < index &&
      !moment(
        `${dayValue}/${monthValue}/2020`,
        format[dayIndex] + "/" + format[dayIndex] + "/YYYY",
        true
      ).isValid()
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkDate = (inputValue, index, append = false) => {
    let inputFormat = format[index];
    if (
      inputValue >= 10 ||
      (inputValue.indexOf("0") === 0 && inputValue.length === 2)
    ) {
      inputValue = inputValue + sep;
      if (index === lastIndex) {
        inputValue = inputValue.slice(0, -1);
      }
    } else if (
      inputValue > (inputFormat.includes("D") ? 3 : 1) &&
      inputValue <= 9
    ) {
      inputValue = (append ? "0" : "") + inputValue + sep;
      if (index === lastIndex) {
        inputValue = inputValue.slice(0, -1);
      }
    }
    return inputValue;
  };

  const checkElse = (inputValue, index, append = false) => {
    let inputFormat = format[index];
    if (index !== lastIndex && inputValue?.length > format[index].length) {
      currVal[index] = inputValue.slice(0, -1) + sep;
    } else if (
      inputValue &&
      (+inputValue > inputFormat.includes("D") ? 31 : 12)
    ) {
      const temp = inputValue.slice(0, -1);
      if (index !== lastIndex && inputValue.length === 2) {
        currVal[index + 1] = inputValue.slice(inputValue.length - 1);
        currVal[index] = (append ? "0" : "") + temp + sep;
        currVal = currVal.slice().map((x) => x.replace(sep, ""));
        currVal = datePattern(
          currVal.join(sep),
          dateFormat,
          sep,
          startYear,
          endYear
        );
      } else if (index === lastIndex) {
        if (inputValue.length === 3) {
          currVal[index] = temp;
        } else if (inputValue.length === 2) {
          currVal[index] = (append ? "0" : "") + temp;
        }
      }
    } else if (
      index === lastIndex &&
      inputValue?.length > format[index].length
    ) {
      currVal[index] = inputValue.slice(0, -1);
    }
    return;
  };

  const checkYear = (inputValue, index) => {
    let val = inputValue?.substring(inputValue?.length - 2);
    if (inputValue?.length === format[index].length) {
      if (index !== lastIndex) {
        inputValue = inputValue + sep;
      } else if (
        index === lastIndex &&
        monthValue === "02" &&
        dayValue === "29" &&
        !moment(`20${val}`).isLeapYear()
      ) {
        inputValue = inputValue.slice(0, -1);
      }
    } else if (inputValue?.length > format[index].length) {
      inputValue = inputValue.slice(0, -1);
    } else {
    }
    return inputValue;
  };

  const checkYearRange = (inputValue, index) => {
    if (inputValue) {
      if (
        inputValue.charAt("0") < startYear.charAt("0") ||
        inputValue.charAt("0") > endYear.charAt("0")
      ) {
        inputValue = inputValue?.slice(0, -1);
      }
      if (
        inputValue.length === 2 &&
        !(
          inputValue >= startYear.substring(0, 2) &&
          inputValue <= endYear.substring(0, 2)
        )
      ) {
        inputValue = inputValue.slice(0, -1);
      }
      if (
        inputValue.length === 3 &&
        (inputValue.charAt("2") < startYear.charAt(2) ||
          inputValue.charAt("2") > endYear.charAt(2))
      ) {
        inputValue = inputValue?.slice(0, -1);
      }
      if (
        inputValue.length === 4 &&
        !(inputValue >= startYear && inputValue <= endYear)
      ) {
        inputValue = inputValue?.slice(0, -1);
      }
      inputValue = checkYear(inputValue, index);
    }
    return inputValue;
  };

  const checkYearSeperator = (inputValue, index) => {
    if (!(value.charAt(value.length - 1) === sep)) {
      inputValue = inputValue.slice(0, -1);
    }
    if (index === lastIndex) {
      if (inputValue.length === 1) {
        inputValue = "200" + inputValue;
      } else if (inputValue.length === 2) {
        inputValue = "20" + inputValue;
      } else if (inputValue.length === 3) {
        inputValue = "2" + inputValue;
      }
    } else if (inputValue.length === 1) {
      inputValue = "200" + inputValue + sep;
    } else if (inputValue.length === 2) {
      inputValue = "20" + inputValue + sep;
    } else if (inputValue.length === 3) {
      inputValue = "2" + inputValue + sep;
    }
    inputValue = checkYear(inputValue, index);
    return inputValue;
  };

  if (format.indexOf("DD") !== -1) {
    if (
      dayValue &&
      (value.charAt(value.length - 1) === sep || isNaN(dayValue))
    ) {
      currVal[dayIndex] = checkSeperator(dayValue, dayIndex, true);
    } else if (validate(`${dayValue}/01/2020`, format[dayIndex] + "/MM/YYYY")) {
      if (checkCorrectDate(dayIndex, monthIndex)) {
        return;
      }
      if (
        dayIndex === lastIndex &&
        !moment(yearValue)?.isLeapYear() &&
        moment()
          .month(monthValue - 1)
          .format("MMMM") === "February" &&
        dayValue >= 29
      ) {
        return;
      }
      currVal[dayIndex] = checkDate(currVal[dayIndex], dayIndex, true);
    } else {
      checkElse(dayValue, dayIndex, true);
    }
  }

  if (format.indexOf("MM") !== -1) {
    if (
      monthValue &&
      (value.charAt(value.length - 1) === sep || isNaN(monthValue))
    ) {
      currVal[monthIndex] = checkSeperator(monthValue, monthIndex, true);
    } else if (validate(monthValue, format[monthIndex])) {
      if (checkCorrectDate(monthIndex, dayIndex)) {
        return;
      }
      if (
        monthIndex === lastIndex &&
        !moment(yearValue)?.isLeapYear() &&
        dayValue === "29" &&
        moment()
          .month(monthValue - 1)
          .format("MMMM") === "February"
      ) {
        return;
      }
      currVal[monthIndex] = checkDate(monthValue, monthIndex, true);
    } else {
      checkElse(monthValue, monthIndex, true);
    }
  }

  if (format.indexOf("YYYY") !== -1) {
    if (
      yearValue &&
      (value.charAt(value.length - 1) === sep || isNaN(yearValue))
    ) {
      currVal[yearIndex] = checkYearSeperator(yearValue, yearIndex);
    } else {
      currVal[yearIndex] = checkYearRange(yearValue, yearIndex);
    }
  }

  if (format.indexOf("YY") !== -1) {
    if (yearValue && isNaN(yearValue)) {
      return;
    }
    currVal[yearIndex] = checkYear(yearValue, yearIndex);
  }

  let updatedDate = currVal.join("");
  let enteredDate = moment(updatedDate, dateFormat).valueOf();
  let endDate = moment().valueOf();
  let updatedMaxDate = moment(maxDate, dateFormat).valueOf();
  let updatedMinDate = moment(minDate, dateFormat).valueOf();

  if (
    updatedDate.length === dateFormat.length &&
    ((!allowFuture && enteredDate > endDate) ||
      (!allowPast && enteredDate < endDate))
  ) {
    if (!allowFuture && enteredDate > endDate) {
      isFutureDate = true;
    } else {
      isPastDate = true;
    }
    updatedDate = updatedDate?.slice(0, -1);
  }

  if (
    updatedDate.length === dateFormat.length &&
    ((maxDate && enteredDate > updatedMaxDate) ||
      (minDate && enteredDate < updatedMinDate))
  ) {
    updatedDate = updatedDate?.slice(0, -1);
  }
  currVal = updatedDate.split(sep);

  return {
    currVal,
    date: parseInt(currVal[dayIndex]),
    month: parseInt(currVal[monthIndex]) - 1,
    year: parseInt(currVal[yearIndex]),
    isFutureDate,
    isPastDate,
  };
};

export { datePattern };
